module.exports = __webpack_public_path__ + "static/media/34-old.f3c80767.png";